module.exports = __webpack_public_path__ + "img/Investment.78ec9db1.jpg";